/*
 * @Author: sunbingqing
 * @Date: 2022-03-03 10:34:50
 * @LastEditors: sunbingqing
 * @LastEditTime: 2022-03-07 17:41:16
 * @Description: 
 * @Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
export default {
  routes: [
    {
      path: '/insure-qrcode',
      name: 'insure-qrcode',
      component: () => import('@/module/teachingTraining/qrcodePage.vue'),
      meta: {
        title: '续费',
        keepAlive: false,
        logined: false
      }
    },{
      path: '/my-insure',
      name: 'my-insure',
      component: () => import('@/module/teachingTraining/myInsure.vue'),
      meta: {
        title: '我的保单',
        keepAlive: false,
        logined: false
      }
    },{
      path: '/insure-bind-phone',
      name: 'insure-bind-phone',
      component: () => import('@/module/teachingTraining/bindPhone.vue'),
      meta: {
        title: '绑定',
        keepAlive: false,
        logined: false
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/teachingTraining.js